<template>
  <v-row class="justify-center">
    <Form
      :items="dataInputs"
      @save="saveEdit"
      @cancel="reset"
      :maxWidth="maxWidth[0]"
      :show="true"
      :showDate="true"
      :showCheck="true"
      :readonly="this.stateReadonly"
    />

    <v-dialog v-model="isLoading" class="dialog__loader" :overlay-opacity="0.3">
      <Loader :loading="isLoading" />
    </v-dialog>
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
  </v-row>
</template>

<script>
import costCenters from "@/store/centrosDeCosto/costCenters";
import date from "@/store/common/date";
import concepts from "@/store/conceptos/concepts";
import modelsLiquidation from "@/store/modelosDeLiquidacion/modelsLiquidation";
import CardsView from "@/components/Complement/CardsView.vue";
import TableWithSearch from "@/components/Complement/TableWithSearch.vue";
import ToolbarTitles from "@/components/Complement/ToolbarTitles.vue";
import ButtonsCardList from "@/components/Complement/ButtonsCardList.vue";
import Form from "../commons/Form.vue";
import DeleteDialog from "@/components/Complement/DeleteDialog.vue";
import Snackbar from "@/components/Complement/Snackbar.vue";
import Loader from "@/components/Complement/Loader.vue";
import operators from "../../../../store/operadores/operators";
import moment from "moment";
import roles from "@/store/autorizaciones/roles";

export default {
  components: {
    TableWithSearch,
    CardsView,
    ToolbarTitles,
    ButtonsCardList,
    Form,
    DeleteDialog,
    Snackbar,
    Loader,
  },
  data() {
    return {
      stateReadonly: true,
      oldItems: null,
      title: this.$tc("modelsLiquidations.modelsLiquidations"),
      titleDelete: this.$tc("modelsLiquidations.toModelLiquidation"),
      isLoading: true,
      maxWidth: ["900px", "500px", "400px"],
      color: "#82A1D0",
      alert: false,
      textAlert: "",
      showCard: true,
      itemId: null,
      showModelRelation: false,
      dataInputsPassChange: [
        {
          name: "pass",
          label: "Password",
          data: "",
          type: "text",
          rules: [
            (v) => !!v || this.$tc("editRegistrations.requerid"),
            (v) =>
              v.length <= 50 || this.$t("validation.maxChart", { max: 50 }),
            (v) =>
              /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d.*\d)[A-Za-z\d]{8,}$/.test(v) ||
              this.$t("validation.passwordRequirements"),
          ],
        },
        {
          name: "pass",
          label: "Password",
          data: "",
          type: "text",
          rules: [
            (v) => !!v || this.$tc("editRegistrations.requerid"),
            (v) =>
              v.length <= 50 || this.$t("validation.maxChart", { max: 50 }),
            (v) =>
              /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d.*\d)[A-Za-z\d]{8,}$/.test(v) ||
              this.$t("validation.passwordRequirements"),
          ],
        },
      ],
      dataInputs: [
        {
          name: "login",
          label: "Login",
          data: "",
          type: "text",
          rules: [
            (v) => !!v || this.$tc("editRegistrations.requerid"),
            (v) =>
              v.length <= 50 || this.$t("validation.maxChart", { max: 50 }),
          ],
        },
        {
          name: "name",
          label: "Nombre",
          data: "",
          type: "text",
          rules: [
            (v) => !!v || this.$tc("editRegistrations.requerid"),
            (v) =>
              v.length <= 50 || this.$t("validation.maxChart", { max: 50 }),
          ],
        },
        {
          name: "dbGrupo",
          label: "DB Grupo",
          data: "",
          type: "text",
          rules: [
            (v) =>
              !v ||
              v.length <= 50 ||
              this.$t("validation.maxChart", { max: 50 }),
          ],
        },
        {
          name: "email",
          label: "Email",
          data: "",
          type: "text",
          rules: [
            (email) =>
              !email ||
              email.length <= 50 ||
              this.$t("validation.maxChart", { max: 50 }),
            (email) =>
              !email ||
              /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) ||
              this.$t("validation.invalidEmailFormat"),
          ],
        },
        {
          data: "",
          name: "roles",
          type: "select",
          label: "roles",
          items: [],
          itemText: "name",
          itemValue: "id",
          rules: [
            (v) =>
              (v !== null && v !== undefined && v !== "") ||
              this.$tc("editRegistrations.requerid"),
          ],
          multiple: false,
          readonly: false,
        },
        {
          name: "token",
          label: "token",
          data: "",
          type: "text",
          rules: [
            (v) =>
              !v ||
              v.length <= 50 ||
              this.$t("validation.maxChart", { max: 50 }),
          ],
        },
      ],

      headers: [
        {
          text: "Nombre",
          value: "name",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Acciones",
          value: "actions",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
          width: "100px",
        },
      ],
    };
  },
  async mounted() {
    try {
      await roles.dispatch("getRoles");
      this.dataInputs[4].items = this.roles;
      await this.setEdit();

      this.isLoading = false;
    } catch (error) {
      console.error(error);
      this.isLoading = false;
    }
  },

  computed: {
    roles() {
      return roles.state.roles || [];
    },
    operators() {
      return operators.state.modelsLiquidations;
    },
    padding() {
      return costCenters.state.paddingNav;
    },
    salaries() {
      return concepts.state.salaries;
    },
    liquidations() {
      return concepts.state.liquidations;
    },

    mode: {
      get() {
        return operators.state.mode;
      },
      set(newValue) {
        return newValue;
      },
    },
    open: {
      get() {
        return operators.state.open;
      },
      set(newvalue) {
        return newvalue;
      },
    },
  },
  methods: {
    showAlert(text, color) {
      this.alert = true;
      this.textAlert = text;
      this.color = color;

      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },

    async saveEdit(newItems) {
      const payload = this.detectChanges(newItems);

      if (Object.keys(payload).length > 0) {
        payload.id = operators.state.edit.operId;

        try {
          operators.commit("setEditRelation", payload);
          await operators.dispatch("edit");
          this.showAlert(this.$tc("operators.editOperatorSuccess"), "#82A1D0");
        } catch (error) {
          if (error.response && error.response.status === 406) {
            this.showAlert(
              this.$tc("modelsLiquidations.editModelLiquidationError"),
              "#ff8d58",
            );

            this.oldItems = { ...this.oldItems };
            this.setEdit();
          } else {
            this.showAlert(
              this.$tc("modelsLiquidations.editModelLiquidationError"),
              "#ff8d58",
            );
          }
        }
      } else {
        this.showAlert(this.$tc("validation.noEditsMessage"), "#F7DC6F");
      }

      this.reset(false);
    },

    detectChanges(newItems) {
      newItems.dateStartInput = date.state.dateFrom;
      newItems.dateEndInput = date.state.dateTo;

      const changes = {};
      const oldItems = this.oldItems;

      function compararFechasSinHora(fecha1, fecha2) {
        return (
          moment.utc(fecha1).format("YYYY-MM-DD") ===
          moment.utc(fecha2).format("YYYY-MM-DD")
        );
      }

      if (
        oldItems &&
        !compararFechasSinHora(oldItems.fecAlta, newItems.dateStartInput)
      ) {
        changes.fecAlta = newItems.dateStartInput + "T00:00:00.000Z";
      }

      if (
        oldItems &&
        !compararFechasSinHora(oldItems.fecBaja, newItems.dateEndInput)
      ) {
        changes.fecBaja = newItems.dateEndInput + "T00:00:00.000Z";
      }

      if (oldItems) {
        if (oldItems.nombre !== newItems.name) {
          changes.nombre = newItems.name;
        }
        if (oldItems.login !== newItems.login) {
          changes.login = newItems.login;
        }
        if (oldItems.dbGrupo !== newItems.dbGrupo) {
          changes.dbGrupo = newItems.dbGrupo;
        }
        if (oldItems.token !== newItems.token) {
          changes.token = newItems.token;
        }

        const oldRoleId =
          oldItems.roles && oldItems.roles.length > 0
            ? oldItems.roles[0].rolId || oldItems.roles[0].id
            : null;

        if (oldRoleId !== newItems.roles) {
          changes.roles = [Number(newItems.roles)];
        }
      }

      return changes;
    },

    resetDate() {
      const today = moment().format("YYYY-MM-DD");
      date.commit("setDateFrom", today);
      date.commit("setDateTo", null);
    },

    reset(value) {
      this.resetDate();
      this.stateReadonly = true;
    },
    cardView(value) {
      this.showCard = value;
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      const year = date.getUTCFullYear();
      const month = String(date.getUTCMonth() + 1).padStart(2, "0");
      const day = String(date.getUTCDate()).padStart(2, "0");

      return `${day}-${month}-${year}`;
    },

    async setEdit(item) {
      if (!operators.state.edit) return;

      if (
        operators.state.edit.operId === 1 ||
        operators.state.edit.operId === 2
      ) {
        this.dataInputs[0].readonly = true;
      }

      this.oldItems = operators.state.edit;
      this.dataInputs[0].data = operators.state.edit.login || "";
      this.dataInputs[1].data = operators.state.edit.nombre || "";
      this.dataInputs[2].data = operators.state.edit.dbGrupo || "";
      this.dataInputs[3].data = operators.state.edit.correoE || "";

      const userRoles = operators.state.edit.roles || [];
      this.dataInputs[4].data =
        userRoles.length > 0 ? userRoles[0].rolId || userRoles[0].id : null;

      this.dataInputs[5].data = operators.state.edit.token || "";

      date.state.dateFrom = moment
        .utc(operators.state.edit.fecAlta)
        .format("YYYY-MM-DD");

      if (operators.state.edit.fecBaja !== null) {
        date.state.dateTo = moment
          .utc(operators.state.edit.fecBaja)
          .format("YYYY-MM-DD");
        date.state.checkTo = false;
      } else {
        date.state.checkTo = true;
      }
    },

    async openDialog(type, item) {
      this.typeForm = type;
      switch (this.typeForm) {
        case "add":
          operators.commit(
            "setMode",
            this.$tc("modelsLiquidations.addModelLiquidation"),
          );
          operators.commit("setOpen", true);
          break;
        case "edit":
          this.itemId = item.liqmodelId;
          operators.commit(
            "setMode",
            this.$tc("modelsLiquidations.editModelLiquidation"),
          );
          this.openEditDialog();
          await this.setEdit(item);

          break;
        case "delete":
          operators.commit("setOpenDelete", true);
          this.itemToDelete = item.liqmodelId;
          break;

        default:
          break;
      }
    },

    deleteItem() {
      operators.commit("setItemDelete", this.itemToDelete);
      modelsLiquidation
        .dispatch("delete")
        .then(() => {
          this.openDelete = false;
          operators.commit("setOpenDelete", false);
          this.showAlert(
            this.$tc("modelsLiquidations.deleteModelLiquidationSuccess"),
            "#82A1D0",
          );
        })
        .catch((e) => {
          this.showAlert(
            this.$tc("modelsLiquidations.deleteModelLiquidationError"),
            "#ff8d58",
          );
        });
    },

    cancelDelete() {
      this.openDelete = false;
      operators.commit("setOpenDelete", false);
    },
  },
};
</script>
